import React from 'react';
import PropTypes from 'prop-types';
import collectionIcon from '../images/p-collection.svg';
import dashboardIcon from '../images/p-dashboard.svg';
import financialsIcon from '../images/p-financials.svg';
import contactsIcon from '../images/p-contacts.svg';
import emailIcon from '../images/email-white.svg';

const NavIcon = ({ type }) => {
  let img;
  switch (type) {
    case 'collection':
      img = collectionIcon;
      break;
    case 'dashboard':
      img = dashboardIcon;
      break;
    case 'financials':
      img = financialsIcon;
      break;
    case 'contacts':
      img = contactsIcon;
      break;
    case 'feedback':
      img = emailIcon;
      break;
    // no default
  }

  return <img src={img} alt={type} className="mainNav-icon" />;
};

NavIcon.propTypes = {
  type: PropTypes.oneOf(['collection', 'dashboard', 'financials', 'contacts', 'feedback']).isRequired,
};

export default NavIcon;



// WEBPACK FOOTER //
// ./src/components/NavIcon.jsx